<template>
  <div id="exhibitor">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'exhibitor'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhibitor/Exhibitor.vue